import React, { useEffect, useState, createElement } from 'react';
import { CheckCircle2, Calendar, Clock, AlertCircle, ArrowRight, XCircle, Check, X } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
  }
}
export function ConfirmationPage() {
  const [showSurvey, setShowSurvey] = useState(false);
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    // Load Wistia player script
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    // Load Wistia embed script
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/3w8fg500m8.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    // Add Wistia styles
    const style = document.createElement('style');
    style.textContent = `wistia-player[media-id='3w8fg500m8']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/3w8fg500m8/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }`;
    document.head.appendChild(style);
    // Load GHL form embed script
    const formScript = document.createElement('script');
    formScript.src = 'https://link.msgsndr.com/js/form_embed.js';
    formScript.async = true;
    document.head.appendChild(formScript);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(embedScript);
      document.head.removeChild(style);
      if (document.head.contains(formScript)) document.head.removeChild(formScript);
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-[#7FFF00]/20 selection:text-[#7FFF00]" data-id="element-1668">
      {/* Progress Bar / Top Indicator */}
      <div className="w-full bg-gray-900 border-b border-gray-800" data-id="element-1669">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between text-sm font-medium text-gray-400" data-id="element-1670">
          <div className="flex items-center gap-2 text-[#7FFF00]" data-id="element-1671">
            <CheckCircle2 className="w-5 h-5" data-id="element-1672" />
            <span data-id="element-1673">Compra Exitosa</span>
          </div>
          <div className="flex items-center gap-2 text-[#7FFF00]" data-id="element-1674">
            <span className="w-6 h-6 rounded-full bg-[#7FFF00]/20 border border-[#7FFF00]/50 flex items-center justify-center text-xs font-bold" data-id="element-1675">
              2
            </span>
            <span data-id="element-1676">Siguiente: Implementación</span>
          </div>
        </div>
      </div>

      <main className="max-w-5xl mx-auto px-4 py-8 md:py-16" data-id="element-1677">
        {/* HERO SECTION */}
        <section className="text-center mb-8 md:mb-12 space-y-8" data-id="element-1678">
          <div className="space-y-4" data-id="element-1679">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-[#7FFF00]/20 border border-[#7FFF00]/50 rounded-full px-4 py-2 mb-4" data-id="element-1680">
              <CheckCircle2 className="w-4 h-4 text-[#7FFF00]" data-id="element-1681" />
              <span className="text-sm font-semibold text-[#7FFF00]" data-id="element-1682">
                Pago Confirmado
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black leading-tight max-w-4xl mx-auto" data-id="element-1683">
              Pago confirmado. <br data-id="element-1684" />
              <span className="text-[#7FFF00]" data-id="element-1685">Paso 1 completado.</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-1686">
              Ya tienes acceso al sistema. Ahora vamos a asegurarnos de que lo
              implementes correctamente y sin perder tiempo.
            </p>
          </div>

          {/* VIDEO EMBED */}
          <div className="max-w-4xl mx-auto space-y-6" data-id="element-1687">
            <div className="relative" data-id="element-1688">
              {/* Neon green gradient shadow */}
              <div className="absolute -inset-2 bg-gradient-to-r from-[#7FFF00] via-[#6FEF00] to-[#7FFF00] opacity-75 blur-2xl" data-id="element-1689"></div>

              <div className="relative aspect-video bg-gray-900 border border-[#7FFF00]/50 overflow-hidden shadow-2xl" data-id="element-1690">
                <wistia-player media-id="3w8fg500m8" aspect="1.7777777777777777" className="w-full h-full" data-id="element-1691"></wistia-player>
              </div>
            </div>

            {/* Support Disclaimer */}
            <div className="bg-gray-900/60 border border-gray-700 rounded-xl p-5 md:p-6 text-left space-y-3" data-id="element-1692">
              <p className="text-white font-bold text-base md:text-lg" data-id="element-1693">
                ¿Necesitás ayuda con acceso o soporte?
              </p>
              <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-1694">
                📩 Para dudas técnicas, acceso, login o facturación:{' '}
                <br className="md:hidden" data-id="element-1695" />
                👉 Escribí a soporte aquí:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00] underline transition-colors" data-id="element-1696">
                  support@truemarketer.com
                </a>
              </p>
              <p className="text-yellow-400 text-sm font-semibold" data-id="element-1697">
                Este call es únicamente para evaluar el programa VIP.
              </p>
            </div>

            <div data-id="element-1698">
              <button onClick={() => setShowSurvey(true)} className="block w-full bg-gradient-to-b from-[#7FFF00] to-[#6FEF00] hover:from-[#6FEF00] hover:to-[#5FDF00] text-black font-bold text-lg md:text-xl rounded-xl py-5 px-8 shadow-lg hover:shadow-[#7FFF00]/20 transition-all duration-300 transform hover:scale-[1.02]" data-id="element-1699">
                <span className="flex items-center justify-center gap-3" data-id="element-1700">
                  APLICAR PARA LA LLAMADA VIP
                  <ArrowRight className="w-5 h-5" data-id="element-1701" />
                </span>
              </button>
              <p className="text-center text-yellow-400 text-sm font-medium mt-3" data-id="element-1702">
                ⚠️ Solo para alumnos listos para avanzar al siguiente nivel.
                Cupos limitados.
              </p>
            </div>
          </div>
        </section>

        {/* VALIDATION SECTION */}
        <section className="max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-1703">
          <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-8 md:p-10" data-id="element-1704">
            <div className="flex gap-4 items-start" data-id="element-1705">
              <AlertCircle className="w-6 h-6 text-yellow-500 shrink-0 mt-1" data-id="element-1706" />
              <div className="space-y-4" data-id="element-1707">
                <h2 className="text-xl font-bold text-white" data-id="element-1708">
                  Muy importante que leas esto:
                </h2>
                <p className="text-gray-300 leading-relaxed" data-id="element-1709">
                  La mayoría de las personas que compran un programa se quedan
                  solas tratando de entender qué hacer primero, qué es prioridad
                  y si lo están haciendo bien.
                </p>
                <p className="text-gray-300 font-medium" data-id="element-1710">
                  Por eso, el siguiente paso recomendado es una llamada corta de
                  implementación.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CALL EXPLANATION */}
        <section className="max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-1711">
          <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-6 md:p-8 space-y-8" data-id="element-1712">
            <div className="text-center space-y-4" data-id="element-1713">
              <h2 className="text-xl md:text-2xl font-bold" data-id="element-1714">
                ¿Querés resultados en serio?
              </h2>
              <p className="text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-1715">
                El programa que acabás de comprar es increíble. Pero la mayoría
                de las personas consumen contenido… y nunca lo ejecutan al nivel
                que deberían. Y por eso no transforman su vida, su negocio o sus
                resultados.
              </p>
            </div>

            {/* VIP Program Intro */}
            <div className="bg-gray-800/50 p-6 rounded-xl border border-[#7FFF00]/30 space-y-4" data-id="element-1716">
              <h3 className="font-bold text-lg text-[#7FFF00] text-center" data-id="element-1717">
                Programa VIP — 6 Meses de Acompañamiento
              </h3>
              <p className="text-gray-300 text-center text-sm" data-id="element-1718">
                Estamos abriendo cupos para trabajar con nosotros de forma
                directa:
              </p>
              <ul className="space-y-3" data-id="element-1719">
                {['Llamadas semanales en vivo', 'Coaching directo', 'Estrategia personalizada', 'Acceso a contenido VIP', 'Acompañamiento real', 'Un sistema completo para que avances rápido'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-1720">
                    <Check className="w-4 h-4 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-1721" />
                    {item}
                  </li>)}
              </ul>
              <p className="text-center text-gray-400 text-sm pt-2" data-id="element-1722">
                Inversión: alrededor de{' '}
                <strong className="text-white" data-id="element-1723">$2,000</strong>
              </p>
            </div>

            {/* Filter Section */}
            <div className="grid md:grid-cols-2 gap-6" data-id="element-1724">
              <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700" data-id="element-1725">
                <h3 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-1726">
                  <XCircle className="w-5 h-5 text-red-400" data-id="element-1727" />
                  Esta llamada NO es
                </h3>
                <ul className="space-y-3" data-id="element-1728">
                  {['Soporte técnico', 'Para preguntas básicas', 'Una consultoría gratis'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-1729">
                      <span className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2 shrink-0" data-id="element-1730" />
                      {item}
                    </li>)}
                </ul>
              </div>

              <div className="bg-gray-800/50 p-6 rounded-xl border border-[#7FFF00]/30" data-id="element-1731">
                <h3 className="font-bold text-lg mb-4 flex items-center gap-2 text-[#7FFF00]" data-id="element-1732">
                  <Check className="w-5 h-5" data-id="element-1733" />
                  Es para personas que
                </h3>
                <ul className="space-y-3" data-id="element-1734">
                  {['Están comprometidas', 'Quieren ir al siguiente nivel', 'Están abiertas a invertir en una mentoría real'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-1735">
                      <span className="w-1.5 h-1.5 bg-[#7FFF00] rounded-full mt-2 shrink-0" data-id="element-1736" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* SELF QUALIFICATION */}
        <section className="max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-1737">
          <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-6 md:p-8 space-y-6" data-id="element-1738">
            <h3 className="text-xl md:text-2xl font-bold text-center" data-id="element-1739">
              Esta llamada es ideal si:
            </h3>

            <div className="space-y-4" data-id="element-1740">
              {['Quieres avanzar más rápido', 'No quieres adivinar si lo estás haciendo bien', 'Prefieres claridad antes que prueba y error', 'Sabes que solo tardarías más sin ayuda'].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-1741">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#7FFF00]/20 border border-[#7FFF00]/50 flex items-center justify-center mt-1" data-id="element-1742">
                    <CheckCircle2 className="w-4 h-4 text-[#7FFF00]" data-id="element-1743" />
                  </div>
                  <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-1744">
                    {item}
                  </p>
                </div>)}
            </div>

            <p className="text-center text-gray-400 pt-4" data-id="element-1745">
              Si eres de los que ejecuta mejor con feedback, esta llamada es
              para ti.
            </p>
          </div>
        </section>

        {/* CTA SECTION */}
        <section className="max-w-2xl mx-auto text-center space-y-6 mb-12 md:mb-16" data-id="element-1746">
          <div className="space-y-2" data-id="element-1747">
            <h2 className="text-2xl md:text-3xl font-bold" data-id="element-1748">
              Agenda tu llamada de implementación ahora
            </h2>
            <p className="text-gray-400" data-id="element-1749">(Los espacios son limitados)</p>
          </div>

          <button onClick={() => setShowSurvey(true)} className="block w-full bg-gradient-to-b from-[#7FFF00] to-[#6FEF00] hover:from-[#6FEF00] hover:to-[#5FDF00] text-black font-bold text-lg md:text-xl rounded-xl py-5 px-8 shadow-lg hover:shadow-[#7FFF00]/20 transition-all duration-300 transform hover:scale-[1.02]" data-id="element-1750">
            <span className="flex items-center justify-center gap-3" data-id="element-1751">
              APLICAR PARA LA LLAMADA VIP
              <ArrowRight className="w-5 h-5" data-id="element-1752" />
            </span>
          </button>

          <p className="text-center text-yellow-400 text-sm font-medium mt-3" data-id="element-1753">
            ⚠️ Solo para alumnos listos para avanzar al siguiente nivel. Cupos
            limitados.
          </p>

          {/* EXPECTATIONS */}
          <div className="bg-gray-900/50 border border-gray-800 rounded-xl p-6 space-y-4" data-id="element-1754">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm text-gray-300" data-id="element-1755">
              <div className="flex flex-col items-center gap-2" data-id="element-1756">
                <Clock className="w-5 h-5 text-[#7FFF00]" data-id="element-1757" />
                <span data-id="element-1758">Duración: 20–30 minutos</span>
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-1759">
                <Check className="w-5 h-5 text-[#7FFF00]" data-id="element-1760" />
                <span data-id="element-1761">No es obligatoria</span>
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-1762">
                <AlertCircle className="w-5 h-5 text-[#7FFF00]" data-id="element-1763" />
                <span data-id="element-1764">Sin presión de venta</span>
              </div>
            </div>
            <p className="text-gray-400 text-sm" data-id="element-1765">
              Si no es un buen fit, te lo diremos. Nuestro objetivo es ayudarte
              a avanzar.
            </p>
          </div>
        </section>

        {/* CLOSING */}
        <section className="text-center space-y-6 max-w-xl mx-auto pb-12" data-id="element-1766">
          <div className="w-16 h-1 bg-gray-700 mx-auto rounded-full" data-id="element-1767" />
          <h3 className="text-xl font-medium text-white" data-id="element-1768">
            Gracias por tomar acción.
          </h3>
          <p className="text-gray-300 leading-relaxed" data-id="element-1769">
            Las personas que obtienen resultados no son las que saben más, sino
            las que ejecutan con claridad.
          </p>
          <p className="font-bold text-[#7FFF00] text-lg" data-id="element-1770">
            Nos vemos en la llamada.
          </p>
        </section>
      </main>

      {/* Survey Modal */}
      {showSurvey && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowSurvey(false)} data-id="element-1771">
          <div className="bg-gray-900 border border-gray-700 rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto relative shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-1772">
            <button onClick={() => setShowSurvey(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors z-10 p-1" data-id="element-1773">
              <X className="w-6 h-6" data-id="element-1774" />
            </button>
            <div className="p-6 pt-12" data-id="element-1775">
              <iframe src="https://api.leadconnectorhq.com/widget/survey/y25LzbmJtTRp1ZfZ0sY8" style={{
            border: 'none',
            width: '100%',
            minHeight: '600px'
          }} scrolling="no" id="y25LzbmJtTRp1ZfZ0sY8" title="survey" data-id="element-1776"></iframe>
            </div>
          </div>
        </div>}

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-8 md:py-12 mt-16" data-id="element-1777">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-1778">
          <div className="mb-6" data-id="element-1779">
            <p className="text-[#7FFF00] font-bold text-lg md:text-xl mb-2" data-id="element-1780">
              48HRSCASHMACHINE.COM
            </p>
          </div>

          <div className="text-gray-400 text-xs md:text-sm leading-relaxed space-y-3" data-id="element-1781">
            <p data-id="element-1782">
              Derechos de autor © 2025, 48 Hrs AI Cash Machine: Todos los
              derechos reservados.
            </p>
            <p className="text-gray-500" data-id="element-1783">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00] transition-colors" data-id="element-1784">
                support@truemarketer.com
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>;
}